import * as React from "react";
import {styled} from "@mui/material/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import {ExpandMore} from '@mui/icons-material';
import {BreadcrumbType, useBreadcrumbs} from "@/store/menu.c";
import {emphasize} from "@mui/material";
import Chip from "@mui/material/Chip";
import SvgIcon from "@mui/material/SvgIcon";
import {useRouter} from "@/helper/hooks";

const StyledBreadcrumb = styled(Chip)(({theme}) => {
    const backgroundColor =
        theme.palette.mode === "light"
            ? theme.palette.grey[50]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        border: 0,
        cursor: "pointer",
        padding: "0.23rem",
        height: theme.spacing(3.8),
        "& .MuiChip-label": {
            fontWeight: 500,
            fontSize: "0.9rem",
        },
        color: theme.palette.text.secondary,
        "&:hover, &:focus": {
            backgroundColor: emphasize(backgroundColor, 0.03),
        },
        "&:active": {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
}) as typeof Chip;

export default function NavbarBreadcrumbs() {
    const breadcrumbs: BreadcrumbType[] = useBreadcrumbs();
    const router = useRouter()

    return (
        <Breadcrumbs aria-label="breadcrumb">
            <StyledBreadcrumb
                component="a"
                size={"medium"}
                onClick={() => router.push('/')}
                label="首页"
                icon={<SvgIcon color={"inherit"} fontSize="small">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0,0,255.99704,255.99704" width="48px" height="48px" fillRule="nonzero">
                        <g fill="#566481" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10"
                           strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none">
                            <g transform="scale(5.33333,5.33333)">
                                <path
                                    d="M23.95117,4c-0.31984,0.01092 -0.62781,0.12384 -0.87891,0.32227l-14.21289,11.19727c-1.8039,1.42163 -2.85937,3.59398 -2.85937,5.89063v19.08984c0,1.36359 1.13641,2.5 2.5,2.5h10c1.36359,0 2.5,-1.13641 2.5,-2.5v-10c0,-0.29504 0.20496,-0.5 0.5,-0.5h5c0.29504,0 0.5,0.20496 0.5,0.5v10c0,1.36359 1.13641,2.5 2.5,2.5h10c1.36359,0 2.5,-1.13641 2.5,-2.5v-19.08984c0,-2.29665 -1.05548,-4.46899 -2.85937,-5.89062l-14.21289,-11.19727c-0.27738,-0.21912 -0.62324,-0.33326 -0.97656,-0.32227zM24,7.41016l13.28516,10.4668c1.0841,0.85437 1.71484,2.15385 1.71484,3.5332v18.58984h-9v-9.5c0,-1.91495 -1.58505,-3.5 -3.5,-3.5h-5c-1.91495,0 -3.5,1.58505 -3.5,3.5v9.5h-9v-18.58984c0,-1.37935 0.63074,-2.67883 1.71484,-3.5332z"></path>
                            </g>
                        </g>
                    </svg>
                </SvgIcon>}
            />
            {breadcrumbs?.map((item: BreadcrumbType, index: number) => (
                <StyledBreadcrumb
                    key={index}
                    component="a"
                    size={"medium"}
                    deleteIcon={<ExpandMore/>}
                    // href={item.path}
                    label={item.name}
                    onDelete={breadcrumbs.length == index + 1 ? () => {
                    } : undefined}
                />
            ))}
        </Breadcrumbs>
    );
}
